var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoopPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 356,
    height: 370,
    viewBox: "0 0 356 370",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "loop-phone-a",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF602F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50.454%",
    stopColor: "#FF0085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2648B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "loop-phone-b",
    x1: "18.745%",
    x2: "89.898%",
    y1: "90.733%",
    y2: "79.268%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF6D42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40.349%",
    stopColor: "#CD0086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2648B2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#loop-phone-a)",
    d: "M215.101,32.001 C176.217,32.125 138.129,49.119 100.951,70.203 L100.951,70.203 C56.561,95.321 13.533,126.304 2.774,168.13 L2.774,168.13 C0.905,175.395 0.011,182.992 1.13686838e-13,190.755 L1.13686838e-13,190.755 L1.13686838e-13,191.049 C0.053,227.902 19.945,268.501 49.811,295.595 L49.811,295.595 C81.5,324.26 124.425,337.816 168.077,337.888 L168.077,337.888 L168.791,337.888 C174.863,337.878 180.957,337.606 187.026,337.079 L187.026,337.079 C236.948,332.808 285.843,311.109 317.888,271.039 L317.888,271.039 C341.036,242.068 355.443,203.54 355.528,166.612 L355.528,166.612 L355.528,165.951 C355.495,151.943 353.394,138.171 348.919,125.253 L348.919,125.253 C332.61,78.023 284.719,42.216 237.898,33.94 L237.898,33.94 C230.553,32.642 223.241,32.023 215.952,32.001 L215.952,32.001 L215.101,32.001 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 356,
    x: 81.875,
    y: 7,
    fill: "#FFF",
    stroke: "#0C1F28",
    strokeWidth: 14,
    rx: 30
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#loop-phone-b)",
    d: "M173.762823,236.446253 C158.421849,236.585658 143.13387,229.522122 134.202415,214.895712 C125.292191,200.304072 126.555389,183.071075 134.343097,169.475986 C142.146506,155.853486 156.50076,133 173.734832,133 C190.841754,133 205.306272,155.942846 213.283877,169.531223 C221.3639,183.294052 233.990158,206.261725 224.766607,220.480253 C215.6141,234.589264 189.06172,236.30723 173.762823,236.446253 L173.762823,236.446253 Z M173.655997,233.689655 C188.0081,233.558698 202.409647,226.718699 210.995739,213.503289 C219.648476,200.185299 218.311214,183.903134 210.731234,171.011981 C203.247335,158.28423 189.677974,148.862069 173.629738,148.862069 C157.462221,148.862069 143.996301,158.20053 136.675817,170.960242 C129.370063,183.69428 146.386108,189.264494 154.74491,202.931966 C163.123629,216.632005 159.264421,233.819492 173.655997,233.689655 L173.655997,233.689655 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 28,
    x: 121,
    fill: "#0C1F28",
    rx: 11.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203,
    cy: 15,
    r: 3,
    fill: "#584380"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 6,
    x: 149,
    y: 12,
    fill: "#584380",
    rx: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoopPhone);
export default __webpack_public_path__ + "static/media/loop-phone.ba759cb9014487ce831fb20c9c490b85.svg";
export { ForwardRef as ReactComponent };